export const TestPassed = (props) => {
    const {testPassed} = props
    return (
        <>
            {testPassed === undefined ? '—' : (testPassed ? '✅' : '❌')}
        </>
    )
}